import React, { useEffect, useMemo, useState } from 'react';
import GetAppIcon from '@material-ui/icons/GetApp';
import { Button } from '@spark/ui-components/components/Button';
import DisponibilidadeFrotaFilter from './DisponibilidadeFrotaFilter';
import DisponibilidadeFrotaTable from './DisponibilidadeFrotaTable';
import FrotaAvailabilityCard from './FrotaAvailabilityCard';
import PosicaoFrotaModal from './PosicaoFrotaModal';
import { useDisponibilidadeFrotaPanel } from '../hooks/useDisponibilidadeFrotaPanel';
import { isSameSelection } from '../utils/selection';
import {
  ButtonIconWrap,
  PanelSection,
  SectionHeader,
  SectionTitle
} from '../DisponibilidadeFrota-styled';

const PainelDisponibilidadeFrota = ({
  tipo,
  titulo,
  tituloFiltro,
  exportFileName,
  sheetName,
  data,
  optionsData = data,
  loading,
  filters,
  filterOverrides,
  resetFiltrosToken,
  selecaoAtiva,
  onToggleSelection,
  onSyncCategoriaAtiva,
  posicoesPorChave,
  onPosicaoLoaded,
  onVisiblePageItemsChange
}) => {
  const [expandedCardKey, setExpandedCardKey] = useState(null);
  const {
    filterConfig,
    filtrosAplicados,
    dataFiltrada,
    paginaAtual,
    quantidadePorPagina,
    setPaginaAtual,
    setQuantidadePorPagina,
    handleApplyFiltros,
    handleExportar,
    handleOpenCardPosicao,
    handleClosePosicao,
    getPositionStatus,
    getPositionTooltip,
    posicaoModal,
    podeSelecionar
  } = useDisponibilidadeFrotaPanel({
    tipo,
    exportFileName,
    sheetName,
    data,
    optionsData,
    filters,
    filterOverrides,
    resetFiltrosToken,
    selecaoAtiva,
    onSyncCategoriaAtiva,
    posicoesPorChave,
    onPosicaoLoaded,
    onVisiblePageItemsChange
  });
  const visibleCardKeys = useMemo(
    () => new Set(dataFiltrada.map(item => item?.codigo || item?.protocolo || `${item?.frota || ''}-${item?.veiculo || ''}`)),
    [dataFiltrada]
  );

  useEffect(() => {
    if (expandedCardKey && !visibleCardKeys.has(expandedCardKey)) {
      setExpandedCardKey(null);
    }
  }, [expandedCardKey, visibleCardKeys]);

  const getCardKey = item => item?.codigo || item?.protocolo || `${item?.frota || ''}-${item?.veiculo || ''}`;

  const handleExpandedCardChange = (item, nextExpanded) => {
    const cardKey = getCardKey(item);
    setExpandedCardKey(nextExpanded ? cardKey : null);
  };

  return (
    <PanelSection>
      <DisponibilidadeFrotaFilter
        loading={loading}
        onApply={handleApplyFiltros}
        onLimpar={handleApplyFiltros}
        title={tituloFiltro}
        filters={filterConfig}
        values={filtrosAplicados}
        collapseOnSearch={true}
      />

      <SectionHeader>
        <SectionTitle>{titulo}</SectionTitle>
        <Button variant="success" onClick={handleExportar}>
          <ButtonIconWrap>
            <GetAppIcon style={{ fontSize: 16 }} />
          </ButtonIconWrap>
          Exportar
        </Button>
      </SectionHeader>

      <DisponibilidadeFrotaTable
        data={dataFiltrada}
        loading={loading}
        totalRegistros={dataFiltrada.length}
        paginaAtual={paginaAtual}
        quantidadePorPagina={quantidadePorPagina}
        setPaginaAtual={setPaginaAtual}
        setQuantidadePorPagina={setQuantidadePorPagina}
        enableCardView={true}
        defaultViewMode="table"
        renderCard={(item, meta) => (
          <FrotaAvailabilityCard
            item={item}
            {...meta}
            onSelect={podeSelecionar ? itemSelecionado => onToggleSelection(tipo, itemSelecionado) : undefined}
            selected={isSameSelection(selecaoAtiva, tipo, item)}
            expanded={expandedCardKey === getCardKey(item)}
            onExpandedChange={nextExpanded => handleExpandedCardChange(item, nextExpanded)}
            onPositionClick={handleOpenCardPosicao}
            getPositionStatus={getPositionStatus}
            getPositionTooltip={getPositionTooltip}
            showPositionButton={tipo === 'tracao'}
          />
        )}
        onRowClick={podeSelecionar ? item => onToggleSelection(tipo, item) : undefined}
        onPositionClick={handleOpenCardPosicao}
        getPositionStatus={getPositionStatus}
        getPositionTooltip={getPositionTooltip}
        showPositionColumn={tipo === 'tracao'}
        showPlotagemColumn={true}
        showTipoOperacaoColumn={tipo === 'tracao'}
        columnConfigKey={`disponibilidade-frota-patio-${tipo}-columns`}
      />

      <PosicaoFrotaModal
        show={posicaoModal.show}
        onHide={handleClosePosicao}
        item={posicaoModal.item}
        loading={posicaoModal.loading}
        error={posicaoModal.error}
        posicao={posicaoModal.posicao}
      />
    </PanelSection>
  );
};

export default PainelDisponibilidadeFrota;
